// Kasa Hareket Raporu kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.cashboxTransactions';

export const cashboxTransactionsGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Kasa Hareket Raporu nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Kasalarınıza giren ve çıkan tüm paraları tarih sırasıyla görürsünüz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    actions: t(`${G}.regions.actions`, 'Loglar ve Excel'),
    filters: t(`${G}.regions.filters`, 'Filtreler'),
    totals: t(`${G}.regions.totals`, 'Dönem özeti'),
    table: t(`${G}.regions.table`, 'Hareket listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Filtreleri açın'),
      text: t(`${G}.s1.text`, '"Filtreleri Göster" düğmesi arama alanlarını açar: Ara, Tür (Tümü / Gelir / Gider), Kasa, Şube, Başlangıç ve Bitiş tarihi. Seçtiğiniz filtreler altta "Aktif" etiketleriyle görünür; etiketin çarpısıyla kaldırabilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube yöneticisi olarak girdiyseniz yalnız kendi şubenizin kasaları listelenir; şube filtresi görünmez.'),
      ],
    },
    {
      region: 'totals',
      title: t(`${G}.s2.title`, '2. Dönem özetini okuyun'),
      text: t(`${G}.s2.text`, 'Kartlar seçtiğiniz filtrelere göre hesaplanır: Devreden Bakiye (başlangıç tarihinden önceki bakiye), Dönem Toplam Geliri, Dönem Toplam Gideri ve Güncel Net Bakiye.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Hareketleri inceleyin'),
      text: t(`${G}.s3.text`, 'Her satırda Tarih, Kasa, Şube, İşlem Türü, Açıklama, Tutar ve Bakiye yer alır. Tablonun altındaki "GENEL TOPLAM" listede görünen gelirlerden giderlerin düşülmesiyle bulunur.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Hatalı hareketi silin'),
      text: t(`${G}.s4.text`, 'Satırın sonundaki ⋮ düğmesinden "Sil" seçin. Silinen hareket kasa bakiyesine ters işlenir: gelir silinirse kasa bakiyesi düşer, gider silinirse artar. Bu işlem geri alınamaz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Faturaya veya hızlı satışa bağlı hareketler (entegrasyon hareketi) buradan silinemez; "Fatura Yönetimine Git" ile ilgili faturayı silmeniz gerekir.'),
        t(`${G}.s4.tip2`, 'Kredi kullandırım ve kredi taksit ödemesi hareketleri de buradan silinemez.'),
        t(`${G}.s4.tip3`, 'Şube yöneticisi kasa hareketi silemez.'),
      ],
    },
    {
      region: 'actions',
      title: t(`${G}.s5.title`, '5. Silinenleri görün, Excel alın'),
      text: t(`${G}.s5.text`, '"Loglar" düğmesi Silinen Kasa İşlemleri listesini açar: kimin, ne zaman, hangi hareketi hangi sebeple sildiği görünür. "Excel İndir" o an listede görünen (filtrelenmiş) hareketleri Excel dosyasına aktarır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sol üstteki geri ok sizi Kasa sayfasına döndürür.'),
      ],
    },
  ],
});
